import { IonContent, IonPage } from '@ionic/react';
import { useMemo, useState } from 'react';
import AlphaInsightsHeader from '../../components/AE2/AlphaInsightsHeader';
import { glossaryTerms } from './glossaryTerms';

import './Homepage.css'
import './Resources.css'

const Resources: React.FC = () => {
  const [search, setSearch] = useState('')

  const grouped = useMemo(() => {
    const q = search.trim().toLowerCase()
    const filtered = glossaryTerms.filter(t =>
      !q || t.term.toLowerCase().includes(q) || t.definition.toLowerCase().includes(q))
    const groups: Record<string, typeof glossaryTerms> = {}
    filtered.forEach(t => {
      const letter = t.term[0].toUpperCase()
      ;(groups[letter] = groups[letter] || []).push(t)
    })
    return groups
  }, [search])

  const letters = Object.keys(grouped).sort()

  return (
    <IonPage className='ae2-home'>
      <AlphaInsightsHeader/>

      <IonContent className='main-bg'>
        <div className='resources-page'>
          <div className='resources-card'>
            <h1>Resources</h1>
            <h2>Glossary of Common Energy Terms</h2>
            <p>
              A quick reference for the building, HVAC, lighting, electrical and water-efficiency
              terms you'll come across when working with energy data and energy management.
            </p>

            <input
              className='resources-search'
              type='search'
              placeholder='Search terms or definitions'
              value={search}
              onChange={e => setSearch(e.target.value)}
            />

            <div className='resources-letters'>
              {letters.map(l => (
                <a key={l} onClick={() => document.getElementById(`glossary-${l}`)?.scrollIntoView({ behavior: 'smooth' })}>
                  {l}
                </a>
              ))}
            </div>

            {letters.length === 0 && <p className='resources-empty'>No terms match your search.</p>}

            {letters.map(l => (
              <section key={l}>
                <h3 id={`glossary-${l}`} className='resources-letter-heading'>{l}</h3>
                <dl>
                  {grouped[l].map(t => (
                    <div key={t.term} className='resources-term'>
                      <dt>{t.term}</dt>
                      <dd>{t.definition}</dd>
                    </div>
                  ))}
                </dl>
              </section>
            ))}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Resources;
